(function () {
  var dataNode = document.getElementById('lbd-configurator-product-data');
  var config;
  var cache = {};
  var requestSequence = 0;
  var timer;

  if (!dataNode) return;
  try {
    config = JSON.parse(dataNode.textContent);
  } catch (error) {
    return;
  }
  if (!config || !Array.isArray(config.optionValueIds)) return;

  function priceLabel(price) {
    return (price / 100).toLocaleString('fr-FR', { maximumFractionDigits: 0 }) + ' €';
  }

  function localVariant(metal, acrylic) {
    if (!Array.isArray(config.variants)) return null;
    var pair = metal.dataset.ral + '-' + acrylic.dataset.code;
    return config.variants.find(function (variant) {
      return (variant.sku && variant.sku.slice(-pair.length) === pair) ||
        (Array.isArray(variant.options) &&
          variant.options[0] === metal.value &&
          variant.options[1] === acrylic.value);
    }) || null;
  }

  function setUnavailable(root, message) {
    var note = root.querySelector('[data-lbd-standard-note]');
    var submit = root.querySelector('.lbd-configurator__submit');
    if (submit) submit.disabled = true;
    if (note) {
      note.hidden = false;
      note.textContent = message;
    }
  }

  function loadVariant(root, metal, acrylic) {
    var metalId = config.optionValueIds[0] && config.optionValueIds[0][metal.value];
    var acrylicId = config.optionValueIds[1] && config.optionValueIds[1][acrylic.value];
    var sectionId = root.id.replace('lbd-configurator-', '');
    var key = metalId + ',' + acrylicId;

    if (!metalId || !acrylicId || !sectionId) {
      return Promise.reject(new Error('Option de personnalisation introuvable'));
    }

    if (!cache[key]) {
      var url = new URL(config.url, window.location.origin);
      url.searchParams.set('option_values', key);
      url.searchParams.set('section_id', sectionId);
      cache[key] = fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Variante introuvable');
          return response.text();
        })
        .then(function (html) {
          var documentFragment = new DOMParser().parseFromString(html, 'text/html');
          var idInput = documentFragment.querySelector('#lbd-configurator-form input[name="id"]');
          if (!idInput || !idInput.value) throw new Error('Variante introuvable');
          return fetch('/variants/' + encodeURIComponent(idInput.value) + '.js');
        })
        .then(function (response) {
          if (!response.ok) throw new Error('Prix de la variante introuvable');
          return response.json();
        });
    }

    return cache[key];
  }

  function resolveSelection(root) {
    var metal = root.querySelector('[data-lbd-metal]');
    var acrylic = root.querySelector('[data-lbd-acrylic]');
    var idInput = root.querySelector('[data-lbd-variant-id]');
    var submit = root.querySelector('.lbd-configurator__submit');
    var referenceInput = root.querySelector('[data-lbd-reference]');
    var referenceText = root.querySelector('.lbd-configurator__reference');
    var currentRequest = ++requestSequence;

    if (!metal || !acrylic || !idInput || !submit) return;

    idInput.value = '';
    submit.disabled = true;

    var exactVariant = localVariant(metal.options[metal.selectedIndex], acrylic.options[acrylic.selectedIndex]);
    if (exactVariant) {
      idInput.value = exactVariant.id;
      root.dataset.resolvedVariantId = String(exactVariant.id);
      root.dataset.resolvedVariantSku = exactVariant.sku || '';
      submit.disabled = exactVariant.available === false;
      root.querySelectorAll('[data-lbd-price]').forEach(function (node) {
        node.textContent = priceLabel(exactVariant.price);
      });
      if (exactVariant.sku) {
        if (referenceInput) referenceInput.value = exactVariant.sku;
        if (referenceText) referenceText.textContent = 'Référence : ' + exactVariant.sku;
      }
      return;
    }

    loadVariant(root, metal.options[metal.selectedIndex], acrylic.options[acrylic.selectedIndex])
      .then(function (variant) {
        if (currentRequest !== requestSequence) return;
        idInput.value = variant.id;
        root.dataset.resolvedVariantId = String(variant.id);
        root.dataset.resolvedVariantSku = variant.sku || '';
        submit.disabled = variant.available === false;
        root.querySelectorAll('[data-lbd-price]').forEach(function (node) {
          node.textContent = priceLabel(variant.price);
        });
        if (variant.sku) {
          if (referenceInput) referenceInput.value = variant.sku;
          if (referenceText) referenceText.textContent = 'Référence : ' + variant.sku;
        }
      })
      .catch(function () {
        if (currentRequest !== requestSequence) return;
        setUnavailable(root, 'Cette combinaison est temporairement indisponible. Merci de nous contacter.');
      });
  }

  function schedule(root) {
    clearTimeout(timer);
    timer = setTimeout(function () { resolveSelection(root); }, 60);
  }

  function start() {
    var root = document.querySelector('.lbd-configurator');
    if (!root) return;
    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-lbd-metal], [data-lbd-acrylic]')) schedule(root);
    });
    schedule(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
